import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  for: "updatePemFile",
  class: "pointer"
}

import { translate } from '@/i18n';
import { showToast } from '@/utils';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonTitle,
  IonToolbar,
  modalController,
} from '@ionic/vue';
import { closeOutline, saveOutline } from 'ionicons/icons';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: ["accountType"],
  setup(__props) {

const props = __props


const uploadedFileName = ref('')

const netSuiteDetails = ref({
  remoteId: '',
  sharedSecret: '',
  sendSharedSecret: '',
  sshKey: '',
  accountType: props.accountType
});
    
const uploadPemFile = async (event: any) => {
  const selectedFile = event.target.files[0];
  if (!selectedFile) {
    return;
  }
  uploadedFileName.value = selectedFile.name 
  netSuiteDetails.value.sshKey = selectedFile;
}
const cancel = () => modalController.dismiss(null, 'cancel');
const confirm = () => {
  const { remoteId, sharedSecret, sendSharedSecret, sshKey } = netSuiteDetails.value;
  if (!remoteId.trim() || !sharedSecret.trim() || !sendSharedSecret.trim() || !sshKey) {
    showToast(translate("Please fill in all fields before saving."));
    return;
  } else {
    modalController.dismiss(netSuiteDetails.value, 'save')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  color: "medium",
                  onClick: cancel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)(props.accountType == "sandbox" ? "Add NetSuite Sandbox credentials" : "Add NetSuite Production credentials")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              "label-placement": "floating",
              label: _unref(translate)('NetSuite Account ID'),
              modelValue: netSuiteDetails.value.remoteId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((netSuiteDetails.value.remoteId) = $event)),
              type: "text",
              required: ""
            }, null, 8, ["label", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              "label-placement": "floating",
              label: _unref(translate)('NetSuite Consumer Key'),
              modelValue: netSuiteDetails.value.sharedSecret,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((netSuiteDetails.value.sharedSecret) = $event)),
              type: "text",
              required: ""
            }, null, 8, ["label", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              "label-placement": "floating",
              label: _unref(translate)('NetSuite Certificate ID'),
              modelValue: netSuiteDetails.value.sendSharedSecret,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((netSuiteDetails.value.sendSharedSecret) = $event)),
              type: "text",
              required: ""
            }, null, 8, ["label", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Private Key")), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonLabel), { class: "ion-text-right ion-padding-end" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(uploadedFileName.value), 1)
              ]),
              _: 1
            }),
            _createElementVNode("input", {
              onChange: uploadPemFile,
              ref: "file",
              type: "file",
              class: "ion-hide",
              id: "updatePemFile",
              accept: ".pem",
              required: ""
            }, null, 544),
            _createElementVNode("label", _hoisted_1, _toDisplayString(_unref(translate)("Upload")), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(IonFab), {
          horizontal: "end",
          vertical: "bottom",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), { onClick: confirm }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})